define('lib/Podio.UI.PushNotifications',['require','translate','underscore','jquery','lib/Podio.Push','lib/Podio.Transport.Reminder','root/audio_video/Podio.UI.AudioVideo.GTMFree','buzz','root/notifications/Podio.Transport.Notifications','lib/Podio.Routes','lib/Podio.Router','lib/Podio.UI','lib/Podio.Config','lib/Podio.Transport','webnotification','lib/view_helpers/base','lib/Podio.Utils','lib/sanitizeHtml'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioPush = require('lib/Podio.Push');
  var reminderTransport = require('lib/Podio.Transport.Reminder');
  var AudioVideoGTMFree = require('root/audio_video/Podio.UI.AudioVideo.GTMFree');
  var buzz = require('buzz');
  var NotificationsTransport = require('root/notifications/Podio.Transport.Notifications');
  var routes = require('lib/Podio.Routes');
  var router = require('lib/Podio.Router');
  var podioUI = require('lib/Podio.UI');
  var podioConfig = require('lib/Podio.Config');
  var transport = require('lib/Podio.Transport');
  var WebNotification = require('webnotification');
  var viewHelpers = require('lib/view_helpers/base');
  var utils = require('lib/Podio.Utils');
  var sanitizeHtml = require('lib/sanitizeHtml');

  var elmWrapper;
  var timers = {}, itemCount = 0;
  var fadeInSpeed = 2500, fadeOutSpeed = 2500, delay = 4000;
  var sounds = {};

  var stickyNotificationTypes = ['meeting_started', 'reminder', 'live_start'];

  var defaultOptions = {
    sticky: false
  };

  var _tpl_wrap = '<ul class="push-notifications-wrapper"></ul>';

  function initWrapper() {
    if (!$('.push-notifications-wrapper').length) {
      $('body').append(_tpl_wrap);
      elmWrapper = $('.push-notifications-wrapper');
    }

    $('.push-notifications-wrapper').toggleClass('chat-pane-offset', $('.layout-podio-narrow').length ? true : false);
  }

  function renderAll(title, text, html, callback, avatar, options, settings) {
    options = _.defaults(options || {}, defaultOptions);
    if (!settings.sound) {
      options.soundFile = null;
    }

    render(html, callback, options);
    renderGrowl(title, text, callback, avatar, options);

    if(settings.browser) {
      renderWebNotification(title, text, callback, avatar, options);
    }
  }

  function render(content, callback, options) {
    initWrapper();

    itemCount++;
    var sanitizedContent = sanitizeHtml(content);
    var elmItem = $(sanitizedContent);

    elmItem.prependTo(elmWrapper);
    elmItem.fadeIn(fadeInSpeed);

    if(!options.sticky) {
      setFadeTimer(elmItem, itemCount);

      elmItem.bind('mouseenter', function(e) {
        cancelFade(elmItem, itemCount);
      });

      elmItem.bind('mouseleave', function(e) {
        setFadeTimer(elmItem, itemCount);
      });
    }

    elmItem.find('.close-button').bind('click', function(){
      fadeOut(elmItem, itemCount);
    });
    elmItem.find('.action-button').bind('click', function(){
      actionButtonClick($(this), function(responseData){
        if (responseData.status == 'ok') {
          fadeOut(elmItem, itemCount);
        }
        podioUI.restoreButtonWithLoader($(this));
      });
    });
    if (callback) {
      elmItem.find('a.default-link').bind('click', callback.curry(false));
    }

    if (options.soundFile) {
      playSound(options.soundFile);
    }
  }

  function playSound(soundPath) {
    var sound = sounds[soundPath];
    if (!sound) {
      sound = new buzz.sound(soundPath, {
        preload: false,
        formats: ["mp3", "wav", "m4a"]
      });

      sounds[soundPath] = sound.load();
    }

    sound.play();
  }

  function actionButtonClick(elmTarget, callback) {
    var providers = {
      gtm_free: AudioVideoGTMFree
    }

    switch(elmTarget.data('action')) {
      case 'read':
        NotificationsTransport.markSingleAsViewed(elmTarget.data('id'), callback);
        break;
      case 'snooze':
        podioUI.disableButtonWithLoader(elmTarget);
        reminderTransport.snooze(elmTarget.data('ref-type'), elmTarget.data('ref-id'), callback);
        break;
      case 'accept-call':
        providers[elmTarget.data('provider')].accept(elmTarget.data('live-id'));
        callback({ status: 'ok' });
        break;
      case 'reject-call':
        providers[elmTarget.data('provider')].reject(elmTarget.data('live-id'));
        callback({ status: 'ok' });
        break;
      case 'other':
        break;
    }
  }

  function fadeOut(elmTarget, unique_id) {

    function onFinished() {
      elmTarget.animate({ height: 0 }, 300, function() {
        elmTarget.remove();

        // Clear timer
        timers['timer_' + unique_id] = null;
        delete timers['timer_' + unique_id];

        if (!_.size(timers)) {
           elmWrapper.remove();
        }
      });
    }

    elmTarget.animate({ opacity: 0 }, fadeOutSpeed, onFinished);
  }

  function cancelFade(elmTarget, unique_id) {
    clearTimeout(timers['timer_' + unique_id]);
    elmTarget.stop().css({ opacity: '' });
  }

  function setFadeTimer(elmTarget, unique_id) {

    timers['timer_' + unique_id] = setTimeout(function() {
      fadeOut(elmTarget, unique_id);
    }, delay);

  }

  function onUserPushNotification(pushData) {

    // Respect user settings;
    if(pushData.settings.popup === false) {
      return;
    }

    showNotification(pushData.notification_id, pushData.settings);
  }

  function renderGrowl(title, text, callback, avatar, options) {
    if (!window.fluid) {
      return; // Fluid not supported
    }

    window.fluid.showGrowlNotification({
      title: title,
      description: text,
      priority: 1,
      sticky: options.sticky,
      identifier: 'podio',
      onclick: callback ? callback.curry(true) : null,
      icon: avatar
    });
  }

  function renderWebNotification(title, text, callback, avatar, options) {
    if(!WebNotification.isSupported()) {
      return; // Web Notifications not supported
    }

    if(WebNotification.permission !== 'granted') {
      return; // No permission
    }

    var notification = new WebNotification(title || t('Podio #notifications'), {
      body: text,
      icon: avatar,
      tag: 'podio-notification-{0}'.format(options.notificationId)
    });

    notification.addEventListener('show', onNotificationDisplayed, true);
    if (callback) {
      notification.addEventListener('click', callback.curry(true), true);
    }
  }

  function onNotificationDisplayed(e) {
    var delay = fadeOutSpeed + fadeInSpeed;

    _.delay(function(){
      // Firefox uses e.target instead of currentTarget,
      // but it also closes the notification itself, no need to handle
      // Safari closes it as well, but there is no harm in calling close().
      if (_.isFunction(e.currentTarget.close)) {
        e.currentTarget.close();
      }
    }, delay);
  }

  function showNotification(notificationId, settings) {

    var req = transport.getJSON(routes.json_notification_path(notificationId));
    req.done(function(responseData) {
      var notification = responseData.data.notification;

      var options = {
        sticky : _.include(stickyNotificationTypes, notification.type),
        soundFile: viewHelpers.sound_url('notification'),
        notificationId: notificationId
      };

      var callback = function(open) {
        transport.postJSON(routes.json_mark_single_as_viewed_path(notificationId), {ajaxParams: {async:false}});
        if (open && notification.context_link) {
          window.location = notification.context_link;
        }
      };

      renderAll(notification.created_by.name, notification.text, responseData.data.html, callback, viewHelpers.avatar_url_for(notification.created_by, 'medium'), options, settings);
    });
  }

  PodioPush.on('user', 'notification_create', onUserPushNotification);

  return {
    showNotification: showNotification,
    render: render,
    renderAll: renderAll,
    playSound: playSound
  };

});

